export default "__VITE_ASSET__CCrpHIeK__"